<template>
  <div class="rank-list">
    <van-image
      class="rank-header"
      fit="cover"
      :src="require('@/assets/img/rank-header.png')"
    />
    <div class="top_picker">
      <div class="current_journal_item" @click="showJournalPicker = true">
        {{ current_journal.text }}
        <van-icon
          class="current_journal_item_icon"
          :name="!showJournalPicker ? 'arrow-down' : 'arrow-up'"
          size="20"
          color="#2a2a2a"
        />
      </div>
    </div>
    <RankList :current_journal="current_journal" @setText="setText" />
  </div>

  <van-popup v-model:show="showJournalPicker" round position="bottom">
    <van-date-picker
      v-model="currentDate"
      title="选择年月"
      :formatter="formatter"
      :columns-type="columnsType"
      @confirm="onJournalPickerConfirm"
      @cancel="showJournalPicker = false"
    />
  </van-popup>
</template>
<script setup>
//引入vant Popup
import {
  Image as VanImage,
  Icon as VanIcon,
  Popup as VanPopup,
  DatePicker as VanDatePicker,
} from "vant";
import { ref, onMounted } from "vue";
import RankList from "../components/RankList.vue";
import useShare from "@/composiables/useShare";
const showJournalPicker = ref(false);
const current_journal = ref({
  text: "",
});
const currentDate = ref([]);
const columnsType = ["year", "month"];
onMounted(() => {
  useShare(
    "中山+月度热评榜丨与您分享观点、知识和情感",
    "https://zsrbapp.zsnews.cn/mobile/images/zsplus.png",
    "携手打造互动、开放、共享的舆论空间",
    window.location.href
  );
  current_journal.value.text = getCurrentYearMonth();
  currentDate.value = dateStringToDateObject(getCurrentYearMonth());
});

const dateStringToDateObject = (dateString) => {
  const [year, month] = dateString.split("-").map(Number);
  return [year, month];
};

const formatter = (type, option) => {
  if (type === "year") {
    option.text += "年";
  }
  if (type === "month") {
    option.text += "月";
  }
  return option;
};

//更新当前期数
const setText = (text) => {
  current_journal.value.text = text.join("-");
  currentDate.value = dateStringToDateObject(text);
};
// 获取当前年月的函数
const getCurrentYearMonth = () => {
  const now = new Date();
  const year = now.getFullYear(); // 获取当前年份
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 获取当前月份，+1是因为getMonth()返回的月份是从0开始的
  return `${year}-${month}`;
};
const onJournalPickerConfirm = ({ selectedValues }) => {
  const year = selectedValues[0];
  const month = selectedValues[1];
  current_journal.value.text = `${year}-${month}`;
  sessionStorage.setItem("text", `${year}-${month}`);
  showJournalPicker.value = false;
};
</script>
<style lang="scss" scoped>
.rank-list {
  background-color: #fcfcda;
  height: 100vh;
  overflow: scroll;
}
.top_picker {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -160px 0 10px;

  .current_journal_item {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    color: #2a2a2a;
    font-size: 14px;
    position: relative;
    z-index: 1;
    padding: 0 12px;
    border-radius: 15px;
    height: 30px;

    &_icon {
      margin-left: 6px;
    }
  }
}

.rank-header {
}
</style>
